<template>
    <main-layout>

        <app-header icon="doc">
            Assemblage
        </app-header>

        <action-bar :back="{name: 'home'}"></action-bar>

        <form id="assemblage" class="wrap">

            <h2>ACQUÉREUR</h2>
            <label>Raison sociale *</label>
            <v-select
                id="id_detenteur"
                :on-change="changeDet"
                :options="detenteursFiltred"
                :filterable="false"
                @search="onSearch">
            </v-select>

            <h2>ÉQUIPEMENT INSTALLÉ</h2>
            <label>Type *</label>
            <div class="radio">
                <input v-model="type_equipement" required type="radio" name="type_equipement" id="radio-clim"
                       value="Climatisation">
                <label for="radio-clim">
                    Climatisation
                    <i class="icon-valid"></i>
                </label>
                <input v-model="type_equipement" required type="radio" name="type_equipement" id="radio-pompe"
                       value="Pompe à chaleur">
                <label for="radio-pompe">
                    Pompe à chaleur
                    <i class="icon-valid"></i>
                </label>
                <div class="clear"></div>
            </div>

            <label>Fluide frigorigène *</label>
            <select v-model.number="id_fluide" name="id_fluide" id="fluide">
                <option selected disabled>Sélectionnez un fluide</option>
                <option value="4">R-134a</option>
                <option value="8">R-32</option>
                <option value="19">R-410A</option>
            </select>

            <h2>INFORMATIONS</h2>
            <label>Période de validité du contrat (en mois) *</label>
            <input title="validatedRange" v-model.number="validite" name="periode_validite" type="number">

            <label>Autres détails</label>
            <textarea title="otherDetails" v-model="details" name="remarque" maxlength="255"></textarea>

            <h2>SIGNATURE</h2>
            <label>Nom acquéreur *</label>
            <input title="clientName" v-model="nom_acquereur" type="text" name="nom_acquereur" value="" required maxlength="255">

            <!--<a class="btn-signature btn" href="javascrit: void 0" @click.prevent="showModal = true">
                SIGNER
                <i class="icon-contract"></i>
            </a>-->

            <a class="btn add btn-full"
               id="main-action"
               :class="contratIsValid ? '' : 'disabled'"
               href="javascript: void 0"
               @click.prevent="triggerSignature">
                <i class="icon-checktodo"></i>
                <strong>Signer et clôturer</strong>le contrat d'assemblage
            </a>

            <signature-modal
                    v-show="showModal"
                    :signature="signature"
                    :clearOnClose="true"
                    @signatureUpdated="updateSignature"
                    @close="showModal = false">
            </signature-modal>

        </form>

    </main-layout>
</template>

<script>
    import Detenteur from '../../../js/models/Detenteur'
    import Assemblage from '../../../js/models/ContratAssemblage'
    import SignatureModal from '../../common/SignatureModal.vue'

    import vSelect from 'vue-select'

    export default {

        data() {
            return {
                detenteursOpt: [],
                detenteursFiltred: [],
                id_detenteur: null,
                type_equipement: null,
                id_fluide: null,
                validite: null,
                details: null,
                nom_acquereur: null,
                signature: null,
                detenteurs: [],
                showModal: false
            }
        },

        methods: {

            sendForm() {

                let data = this.$data;
                let contrat = new Assemblage;

                if (document.getElementById('main-action').classList.contains('disabled')) {

                    swal('Fiche incomplète', 'Veuillez finir de remplir la fiche avant de la clôturer', 'warning')

                } else {

                    contrat
                        .saveContrat(data)
                        .then(() => {
                            this.$router.push('home');
                            swal("Contrat d'assemblage terminé", "le contrat d'assemblage a bien été généré", 'success')
                        })
                        .catch(() => {
                            swal("Erreur", "une erreur s'est produite lors de l'enregistrement du contrat d'assemblage", 'error')
                        })

                }

            },

            triggerSignature() {
                if( this.contratIsValid) {
                    this.showModal = true
                }  else {
                    swal('Fiche incomplète', 'Veuillez finir de remplir la fiche avant de la clôturer', 'warning')
                }
            },

            changeDet(val) {
                this.id_detenteur = val.value
            },

            fetchDetenteurs() {
                Detenteur.getList().then(data => {

                    let dets = _.sortBy(data,  [det => det.raison_sociale.toUpperCase()]);

                    this.detenteursOpt = dets.map(det => {
                        let label = det.raison_sociale;
                        label += (det.code_client) ? ' (' + det.code_client + ') - ' : ' - ';
                        label += det.ville + ' / ' + det.code_postal;

                        return {
                            value: det.id,
                            label
                        }
                    });

                    this.detenteursFiltred = this.detenteursOpt.slice(0, 20);

                })
            },

            onSearch(str) {
                str = this.normalize(str);

                this.detenteursFiltred = this.detenteursOpt.filter( det =>  {
                    if(this.normalize(det.label).includes(str)) { return det }
                }).slice(0, 20)
            },

            normalize(s) {
                let r = s.toLowerCase();

                r = r.replace(new RegExp(/\s/g),"");
                r = r.replace(new RegExp(/[àáâãäå]/g),"a");
                r = r.replace(new RegExp(/æ/g),"ae");
                r = r.replace(new RegExp(/ç/g),"c");
                r = r.replace(new RegExp(/[èéêë]/g),"e");
                r = r.replace(new RegExp(/[ìíîï]/g),"i");
                r = r.replace(new RegExp(/ñ/g),"n");
                r = r.replace(new RegExp(/[òóôõö]/g),"o");
                r = r.replace(new RegExp(/œ/g),"oe");
                r = r.replace(new RegExp(/[ùúûü]/g),"u");
                r = r.replace(new RegExp(/[ýÿ]/g),"y");
                r = r.replace(new RegExp(/\W/g),"");

                return r;
            },

            updateSignature(data) {
                this.signature = data;
                this.sendForm()
            }

        },

        computed: {
            contratIsValid() {
                return (this.id_detenteur && this.type_equipement && this.id_fluide && this.validite && this.nom_acquereur);
            }
        },

        mounted() {
            this.fetchDetenteurs()
        },

        components: {
            SignatureModal,
            vSelect
        }

    }

</script>

<style scoped>

    #main-action.disabled {
        background-color: #e2e2e2;
        color: #999;
        font-style: italic;
    }

    #main-action{
        margin-left: 0;
        margin-bottom: 20px;
    }

    #assemblage {
        padding-top: 5px;
    }

    #assemblage h2 {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    #assemblage .btn-signature {
        background-color: #5698d2;
        color: white;
        width: 120px;
        padding-left: 20px;
        margin: auto;
        margin-top: 15px;
        margin-bottom: 20px;
    }

    #assemblage .btn-signature i {
        right: 0;
        top: 50%;
        margin-top: -16px;
        font-size: 3rem;
    }

    #assemblage div.radio {
        width: 100%;
        float: none;
    }

    #assemblage div.radio label {
        width: 100%;
    }

    div.radio label {
        display: block;
        position: relative;
        height: 50px;
        width: 100px;
        border-radius: 5px;
        background-color: #e2e2e2;
        color: #999;
        padding-left: 20px;
        line-height: 3.5;
        transition: all 250ms ease;
    }

    div.radio input {
        display: none;
    }

    div.radio {
        display: block;
        float: left;
        margin-right: 20px;
        margin-bottom: 15px;
    }

    #assemblage div.radio {
        width: 100%;
        float: none;
    }

    label {
        font-size: 1.4rem;
        text-transform: uppercase;
        margin-bottom: 5px;
        display: block;
        color: #666;
    }

    div.radio label i {
        position: absolute;
        right: 10px;
        top: 15px;
        font-size: 2rem;
        color: #999;
    }

    div.radio input:checked + label {
        background-color: #86bc24;
        color: #fff;
    }

    div.radio input:checked + label i {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// ContratAssemblage.vue?005b667e